import type { ResponseEnvelope } from '@storeflare/types';

const BASE = import.meta.env['VITE_API_BASE'] ?? '/api';

export class WebApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details?: Record<string, unknown>,
  ) {
    super(message);
  }
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const url = new URL(path.replace(/^\//, ''), `${BASE.replace(/\/?$/, '/')}`);
  const res = await fetch(url.toString(), {
    credentials: 'include',
    headers: {
      accept: 'application/json',
      ...(init.body ? { 'content-type': 'application/json' } : {}),
      ...(init.headers ?? {}),
    },
    ...init,
  });

  let envelope: ResponseEnvelope<T>;
  try {
    envelope = (await res.json()) as ResponseEnvelope<T>;
  } catch {
    throw new WebApiError(res.status, 'PARSE_ERROR', `Failed to parse response (HTTP ${res.status})`);
  }

  if (envelope.error) {
    throw new WebApiError(res.status, envelope.error.code, envelope.error.message, envelope.error.details);
  }
  return envelope.data as T;
}
